export const BASE_URL = `${process.env.BASE_URL_GATEWAY || ""}`;
import { Service } from "@warda/library-ui/contexts/AppWebSocketContext";
const apiUrlsNotifier = {
    createNotification: {
        url: () => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}`,
        method: "POST",
    },
    removeNotification: {
        url: (id) => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}/${id}`,
        method: "DELETE",
    },
    notificationMarkRead: {
        url: (id, mark) => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}/${id}/read?mark=${mark}`,
        method: "PUT",
    },
    notificationMarkAllRead: {
        url: (mark) => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}/read?mark=${mark}`,
        method: "PUT",
    },
    notificationMarkView: {
        url: (id, mark) => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}/${id}/view?mark=${mark}`,
        method: "PUT",
    },
    notificationMarkAllView: {
        url: (mark) => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}/view?mark=${mark}`,
        method: "PUT",
    },
    deleteNotifications: {
        url: () => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}`,
        method: "DELETE",
    },
    getNotifications: {
        url: (size, from, filter) => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}?size=${size}&from=${from}${!filter ? "" : `&filter=${filter}`}`,
        method: "GET",
    },
    getNotificationsCount: {
        url: (filter) => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}/count?${!filter ? "" : `&filter=${filter}`}`,
        method: "GET",
    },
    getNotificationById: {
        url: (id) => `${BASE_URL}/${Service.NOTIFIER}/notifications/${Service.SC}/${id}`,
        method: "GET",
    },
    getJobs: {
        url: () => `${BASE_URL}/${Service.NOTIFIER}/jobs/${Service.SC}?size=250&from=0`,
        method: "GET",
    },
    getJobId: {
        url: (id) => `${BASE_URL}/${Service.NOTIFIER}/jobs/${Service.SC}/${id}`,
        method: "GET",
    },
    deleteJobs: {
        url: () => `${BASE_URL}/${Service.NOTIFIER}/jobs/${Service.SC}`,
        method: "DELETE",
    },
    deleteJobId: {
        url: (id) => `${BASE_URL}/${Service.NOTIFIER}/jobs/${Service.SC}/${id}`,
        method: "DELETE",
    },
};
export default apiUrlsNotifier;
